var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 588.91 477.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10{fill:#c1cdde;}.cls-1{opacity:0.54;}.cls-2{fill:url(#New_Gradient_Swatch_34);}.cls-3{fill:url(#New_Gradient_Swatch_34-2);}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#New_Gradient_Swatch_34-3);}.cls-6{fill:url(#New_Gradient_Swatch_34-4);}.cls-7{fill:url(#New_Gradient_Swatch_34-5);}.cls-8{fill:url(#New_Gradient_Swatch_34-6);}.cls-9{fill:url(#New_Gradient_Swatch_34-7);}.cls-11{fill:#15285c;opacity:0.09;}.cls-12,.cls-13,.cls-14,.cls-15{fill:#fff;}.cls-12{opacity:0.33;}.cls-13,.cls-32,.cls-33{opacity:0.23;}.cls-14{opacity:0.55;}.cls-16{fill:url(#New_Gradient_Swatch_36);}.cls-17,.cls-43{fill:#f4f5f8;}.cls-17{opacity:0.52;}.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-26,.cls-27{opacity:0.16;}.cls-18{fill:url(#New_Gradient_Swatch_9);}.cls-19{fill:url(#New_Gradient_Swatch_9-2);}.cls-20{fill:url(#New_Gradient_Swatch_9-3);}.cls-21{fill:url(#New_Gradient_Swatch_9-4);}.cls-22{fill:url(#New_Gradient_Swatch_9-5);}.cls-23{fill:url(#New_Gradient_Swatch_36-2);}.cls-24{opacity:0.3;fill:url(#New_Gradient_Swatch_35);}.cls-25{fill:#d4e2f9;opacity:0.31;}.cls-26{fill:url(#New_Gradient_Swatch_35-2);}.cls-27{fill:url(#New_Gradient_Swatch_9-6);}.cls-28{fill:url(#New_Gradient_Swatch_4);}.cls-29{fill:url(#New_Gradient_Swatch_19);}.cls-30{fill:url(#New_Gradient_Swatch_4-2);}.cls-31{opacity:0.59;fill:url(#New_Gradient_Swatch_9-7);}.cls-32{fill:url(#New_Gradient_Swatch_9-8);}.cls-33{fill:url(#New_Gradient_Swatch_9-9);}.cls-34{fill:url(#New_Gradient_Swatch_13);}.cls-35,.cls-37,.cls-38{opacity:0.17;}.cls-35{fill:url(#New_Gradient_Swatch_4-3);}.cls-36{fill:url(#New_Gradient_Swatch_4-4);}.cls-37{fill:url(#New_Gradient_Swatch_4-5);}.cls-38{fill:url(#New_Gradient_Swatch_4-6);}.cls-39{fill:url(#New_Gradient_Swatch_4-7);}.cls-40{fill:url(#New_Gradient_Swatch_4-8);}.cls-41{fill:#9499ee;}.cls-42{fill:#7f83cc;}.cls-44,.cls-45{opacity:0.74;}.cls-44{fill:url(#New_Gradient_Swatch_4-9);}.cls-45{fill:url(#New_Gradient_Swatch_4-10);}.cls-46{fill:#545e78;}.cls-47{opacity:0.08;}.cls-48{fill:#e1e7ef;}.cls-49{fill:url(#New_Gradient_Swatch_31);}.cls-50,.cls-52,.cls-60,.cls-61,.cls-66,.cls-71{opacity:0.04;}.cls-50{fill:url(#linear-gradient-2);}.cls-51{fill:url(#New_Gradient_Swatch_31-2);}.cls-52{fill:url(#linear-gradient-3);}.cls-53{fill:url(#New_Gradient_Swatch_31-3);}.cls-54,.cls-55,.cls-56,.cls-57{fill:#d7e0fd;}.cls-54{opacity:0.13;}.cls-55{opacity:0.35;}.cls-56{opacity:0.46;}.cls-57{opacity:0.18;}.cls-58{opacity:0.29;fill:url(#New_Gradient_Swatch_9-10);}.cls-59{fill:url(#New_Gradient_Swatch_31-4);}.cls-60{fill:url(#linear-gradient-4);}.cls-62{opacity:0.07;fill:url(#linear-gradient-5);}.cls-63{fill:url(#New_Gradient_Swatch_31-5);}.cls-64{opacity:0.12;fill:url(#linear-gradient-6);}.cls-65{fill:url(#New_Gradient_Swatch_31-6);}.cls-66{fill:url(#linear-gradient-7);}.cls-67,.cls-68,.cls-69{opacity:0.19;}.cls-67{fill:url(#linear-gradient-8);}.cls-68{fill:url(#linear-gradient-9);}.cls-69{fill:url(#linear-gradient-10);}.cls-70{fill:url(#New_Gradient_Swatch_31-7);}.cls-71{fill:url(#linear-gradient-11);}.cls-72{opacity:0.05;fill:url(#linear-gradient-12);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_34",
    x1: 1098.98,
    y1: 78.11,
    x2: 992.14,
    y2: 177,
    gradientTransform: "translate(-302.43 -420.78) rotate(26.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#a6d1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#59b1f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4969ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_34-2",
    x1: 1133.32,
    y1: -52.43,
    x2: 1092.74,
    y2: 15.4,
    gradientTransform: "matrix(0.77, 0.42, -0.54, 0.99, -282.86, -325.19)",
    xlinkHref: "#New_Gradient_Swatch_34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 569.09,
    y1: -36.9,
    x2: 445.34,
    y2: 214.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6d1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#59b1f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4969ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_34-3",
    x1: 589.52,
    y1: -46.8,
    x2: 519.52,
    y2: 70.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_34-4",
    x1: -24.81,
    y1: 100.18,
    x2: 55.86,
    y2: 85.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_34-5",
    x1: 3.44,
    y1: 87.79,
    x2: 34.19,
    y2: 87.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_34-6",
    x1: -46.74,
    y1: 27.63,
    x2: 111.93,
    y2: 82.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_34-7",
    x1: -15.75,
    y1: 90.93,
    x2: 67.58,
    y2: 69.93,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36",
    x1: 7.06,
    y1: 67.35,
    x2: 131.06,
    y2: 284.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8d7e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_9",
    x1: 27.27,
    y1: 165.71,
    x2: 113.28,
    y2: 165.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bec7da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7aec7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_9-2",
    x1: 35.9,
    y1: 126.08,
    x2: 97.55,
    y2: 126.08,
    xlinkHref: "#New_Gradient_Swatch_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_9-3",
    x1: 50.08,
    y1: 209.32,
    x2: 142.26,
    y2: 209.32,
    xlinkHref: "#New_Gradient_Swatch_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_9-4",
    x1: 76.56,
    y1: 269.49,
    x2: 121.39,
    y2: 269.49,
    xlinkHref: "#New_Gradient_Swatch_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_9-5",
    x1: 125.27,
    y1: 243.23,
    x2: 149.8,
    y2: 243.23,
    xlinkHref: "#New_Gradient_Swatch_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_36-2",
    x1: 110.49,
    y1: 245.07,
    x2: 112.99,
    y2: 313.07,
    xlinkHref: "#New_Gradient_Swatch_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_35",
    x1: 48.9,
    y1: 149.32,
    x2: 65.04,
    y2: 149.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8da7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b84e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_35-2",
    x1: 70.06,
    y1: 132.33,
    x2: 130.18,
    y2: 132.33,
    xlinkHref: "#New_Gradient_Swatch_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_9-6",
    x1: 147.27,
    y1: 255.75,
    x2: 172.14,
    y2: 255.75,
    xlinkHref: "#New_Gradient_Swatch_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 476.78,
    y1: 368.07,
    x2: 478.67,
    y2: 368.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dee4ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_19",
    x1: 436.37,
    y1: 271.76,
    x2: 462.37,
    y2: 225.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7cfd6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 482.6,
    y1: 188.89,
    x2: 459.76,
    y2: 255.06,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_9-7",
    x1: 529.75,
    y1: 214.94,
    x2: 487.75,
    y2: 207.6,
    xlinkHref: "#New_Gradient_Swatch_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_9-8",
    x1: 412.95,
    y1: 267.8,
    x2: 452.98,
    y2: 267.8,
    xlinkHref: "#New_Gradient_Swatch_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_9-9",
    x1: 412.34,
    y1: 251.56,
    x2: 496.64,
    y2: 251.56,
    xlinkHref: "#New_Gradient_Swatch_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_13",
    x1: 261.67,
    y1: 377.78,
    x2: 259.01,
    y2: 494.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dce3ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-3",
    x1: 196.76,
    y1: 369.37,
    x2: 196.76,
    y2: 411.87,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-4",
    x1: 372.37,
    y1: 349.44,
    x2: 359.04,
    y2: 338.11,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-5",
    x1: 473.82,
    y1: 390.72,
    x2: 457.82,
    y2: 427.05,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-6",
    x1: 487.55,
    y1: 345.67,
    x2: 480.8,
    y2: 360.67,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-7",
    x1: 302,
    y1: 347.18,
    x2: 159,
    y2: 313.18,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-8",
    x1: 443.15,
    y1: 351.98,
    x2: 405.15,
    y2: 345.98,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-9",
    x1: 416.49,
    y1: 305.19,
    x2: 400.11,
    y2: 301.22,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-10",
    x1: 375.69,
    y1: 296.35,
    x2: 354.99,
    y2: 292.22,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_31",
    x1: 177.16,
    y1: 219.46,
    x2: 236.28,
    y2: 219.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ced6de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 206.65,
    y1: 193.13,
    x2: 234.07,
    y2: 228.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48485c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95a2d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_31-2",
    x1: 200.93,
    y1: 197.41,
    x2: 228.15,
    y2: 197.41,
    xlinkHref: "#New_Gradient_Swatch_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 208.92,
    y1: 181.8,
    x2: 228.45,
    y2: 207.31,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_31-3",
    x1: 91.05,
    y1: 239.96,
    x2: 118.8,
    y2: 281.21,
    xlinkHref: "#New_Gradient_Swatch_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_9-10",
    x1: 200.93,
    y1: 260.03,
    x2: 299.93,
    y2: 260.03,
    xlinkHref: "#New_Gradient_Swatch_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_31-4",
    x1: 105.12,
    y1: 274.48,
    x2: 104.79,
    y2: 290.81,
    xlinkHref: "#New_Gradient_Swatch_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 107.77,
    y1: 242.93,
    x2: 105.44,
    y2: 234.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 188.36,
    y1: 299.99,
    x2: 249.94,
    y2: 299.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#433ea3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0357ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_31-5",
    x1: 297.35,
    y1: 238.23,
    x2: 303.6,
    y2: 258.48,
    xlinkHref: "#New_Gradient_Swatch_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 302.67,
    y1: 254.89,
    x2: 301.29,
    y2: 246.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_31-6",
    x1: 207.27,
    y1: 313.08,
    x2: 207.6,
    y2: 325.75,
    xlinkHref: "#New_Gradient_Swatch_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 147.04,
    y1: 338.38,
    x2: 301.29,
    y2: 311.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 286.4,
    y1: 312.82,
    x2: 294.6,
    y2: 311.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 243.89,
    y1: 329.74,
    x2: 298.87,
    y2: 320.21,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 285.71,
    y1: 333.54,
    x2: 294.68,
    y2: 331.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_31-7",
    x1: 217.04,
    y1: 310.32,
    x2: 212.37,
    y2: 326.65,
    xlinkHref: "#New_Gradient_Swatch_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 219.87,
    y1: 322.53,
    x2: 277.04,
    y2: 314.53,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 251.13,
    y1: 319.79,
    x2: 258.3,
    y2: 330.45,
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "i 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape_Bg",
    "data-name": "Shape Bg",
    className: "cls-1",
    x: 77.49,
    y: 5.69,
    width: 361.03,
    height: 325.55,
    rx: 19.59,
    ry: 19.59,
    transform: "translate(-5.89 9.38) rotate(-2.06)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Leafs_Right",
    "data-name": "Leafs Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Lower_leaf",
    "data-name": "Lower leaf",
    className: "cls-2",
    d: "M471.47,222.77c-9.29-11.3-18.67-31.62-11.31-44.34s13.13-28.52,25.4-33,22.71,1.68,33.43-4.9,23.22-14.07,35-10,31.24,1.39,34.33,11.67-6.54,13.65-16.67,16.66-10.65,6.31-27.38,10.91S541.8,191,530.65,209.17,497.14,239.86,471.47,222.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Middle_strokes",
    "data-name": "Middle strokes",
    className: "cls-3",
    d: "M485.36,224.86a128.83,128.83,0,0,1,6.86-32.2c-1.49-4.24-2.67-8.6-3.93-12.91,1.75,3.21,3.48,6.44,5.31,9.6,9.72-18.83,25-38.73,46.36-44.29,2.59-3.37,5.3-6.64,7.74-10.11-1.7,3.17-3.56,6.26-5.36,9.38a97.47,97.47,0,0,1,26.56-3.17c-8.12,1.66-16.34,1.67-24.22,4.51,3.34,1.63,6.6,3.4,9.86,5.17-3.71-1.37-7.27-2.94-11.15-4-11.82,3.45-22.66,11.78-30.34,20.27-7.51,8.29-11.3,14.27-16.78,23.11,3.61-.51,7-.83,10.54-1.23-3.74,1.23-7.53,2.36-11.19,3.8C490.86,203.07,488,213.9,485.36,224.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Upper_leaf",
    "data-name": "Upper leaf",
    className: "cls-4",
    d: "M456.56,220.51s-45-32.49-36-55.66,2.81-47.91,17.4-58,40.6-12.23,47.6-22.18,12-40.95,33-44.95,41-18,51-10,.66,27.37-6.67,34-6.67,20-31.33,36.65,4,46-.67,60.67S516.89,229.35,456.56,220.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Middle_strokes-2",
    "data-name": "Middle strokes",
    className: "cls-5",
    d: "M457.49,211.49s-2.84-16.33,3.57-44.06L448,152.16l14,10.5c6.14-25.84,24-63.92,45.48-82.75V62.16l2.5,15s20.5-21,33-27c0,0-24.34,20.33-28.34,26.66l19.5-3-20,5.34S491.82,104,481.82,125.82a349.66,349.66,0,0,0-14.67,37l17.67-5.66-17.67,9.33S458.65,193.32,457.49,211.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Leafs_left",
    "data-name": "Leafs left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Lower_leaf-2",
    "data-name": "Lower leaf",
    className: "cls-6",
    d: "M106.34,87c-22.08,18.82-44.8,22.81-61.25,22.4-.4-2.18-2.65-3.85-5.35-3.85a5.45,5.45,0,0,0-5.08,3,67.91,67.91,0,0,1-13.75-3.27s-.43-34.5,35.17-42.9C92.82,53.73,106.34,87,106.34,87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Middle_strokes-3",
    "data-name": "Middle strokes",
    className: "cls-7",
    d: "M103.86,84.31S70.17,63.75,28.48,99.57c0,0,34.61-36.38,72.39-18.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Upper_leaf-2",
    "data-name": "Upper leaf",
    className: "cls-8",
    d: "M106.32,83.1C69,97,40.55,89.52,23.63,81.09c1.19-2.15.39-5.13-3.56-5.43a2.82,2.82,0,0,0-3,1.79A65,65,0,0,1,5.82,69.1s9.76-24.22,43.11-29.5c0,.13-.15,3.9,6.64,4,6.54.06,6.66-4.54,6.42-5h1.33C108.32,39.1,106.32,83.1,106.32,83.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Middle_strokes-4",
    "data-name": "Middle strokes",
    className: "cls-9",
    d: "M103.67,79.09S74,43.4,14,67.41c0,0,52.33-27.32,87.67,6.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UI"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape_Bg-2",
    "data-name": "Shape Bg",
    className: "cls-10",
    x: 96.6,
    y: 19.72,
    width: 361.03,
    height: 325.55,
    rx: 19.59,
    ry: 19.59
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shapes"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 130.26,
    y: 95.41,
    width: 216.67,
    height: 20.36,
    rx: 10.18,
    ry: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 130.26,
    y: 124.75,
    width: 216.67,
    height: 20.36,
    rx: 10.18,
    ry: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 130.26,
    y: 236.08,
    width: 216.67,
    height: 20.36,
    rx: 10.18,
    ry: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 130.26,
    y: 265.41,
    width: 216.67,
    height: 20.36,
    rx: 10.18,
    ry: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 130.26,
    y: 294.75,
    width: 216.67,
    height: 20.36,
    rx: 10.18,
    ry: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 130.26,
    y: 161.41,
    width: 216.67,
    height: 63.33,
    rx: 20.25,
    ry: 20.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 357.6,
    y: 95.41,
    width: 76,
    height: 129.33,
    rx: 4.45,
    ry: 4.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 357.6,
    y: 236.08,
    width: 76,
    height: 79.02,
    rx: 9.72,
    ry: 9.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 130.26,
    y: 49.08,
    width: 303.33,
    height: 28,
    rx: 14,
    ry: 14
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 144.7,
    cy: 63.08,
    r: 8.11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Paper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper_Back",
    "data-name": "Paper Back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG_Shape",
    "data-name": "BG Shape",
    className: "cls-16",
    d: "M12.84,121.19,99.38,83A7.62,7.62,0,0,1,110,91.28c-2,12-3.5,31.28,11.17,47.27,28,30.51,44.43,70.5,40.05,109.72-.58,5.16-2.7,10-7.33,12.35L69,321.36a7.61,7.61,0,0,1-11-7.19c1.16-20.55,7.3-64.21-20.84-92.56C5.81,190.08-6,162.24,2.86,133.41,4.49,128.09,7.76,123.43,12.84,121.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shapes-2",
    "data-name": "Shapes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M31.52,145.43c2,5.43.34,11.43-3.81,13s-9-1.46-11-6.89,1.07-11.61,5.22-13.15C27,136.48,29.5,140,31.52,145.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M29.13,168.33l64.8-36a3.7,3.7,0,0,1,5.34,2.12c1.68,5.94,10.36,16.48,13.15,19.52a3.65,3.65,0,0,1-1.07,5.54c-22.11,12.91-43,26.81-65.14,39.69-1.59.93-3.31.23-4.79-.87C36.7,194.77,29,182.14,27.36,172.85,27.05,171,27.52,169.2,29.13,168.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M37.41,130.79l55.66-26.65a2.49,2.49,0,0,1,3.51,2.22c.25,3,.49,6.94.92,9.43a2.6,2.6,0,0,1-1.13,2.86L43,148a2.55,2.55,0,0,1-3.43-1.19c-1.8-3.17-4.21-9.23-3.51-14A2.56,2.56,0,0,1,37.41,130.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M51.26,213.16C58,219.4,68.82,234.52,72,248.28c.75,3.19,4.88,4.32,7.68,2.51l60.21-39a5,5,0,0,0,2.18-5.43c-2.3-9.14-6.24-30.47-20.8-38.35-1.92-1-4.11-1.46-6-.31L52.67,205.89C50.14,207.47,49.08,211.16,51.26,213.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M78.23,263.27l35.93-23a3.48,3.48,0,0,1,5.21,2.18,77.35,77.35,0,0,1,1.15,29.5A3.5,3.5,0,0,1,119,274.4L84.66,298.61a3.48,3.48,0,0,1-5.41-3.08A99.44,99.44,0,0,0,76.64,267,3.49,3.49,0,0,1,78.23,263.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M126.75,229.83l14.43-9.22a3.68,3.68,0,0,1,5.24,1.73c3.41,6.78,4.18,22.68,2.58,30.93a3.54,3.54,0,0,1-1.57,2.53l-14.68,10c-2.25,1.35-5.32,0-5.24-2.35.15-4.58,1.6-18.46-2.1-30.2A3,3,0,0,1,126.75,229.83Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Paper_Front",
    "data-name": "Paper Front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG_shape-2",
    "data-name": "BG shape",
    className: "cls-23",
    d: "M48.67,121l90.15-28.59a7.62,7.62,0,0,1,9.63,9.34c-3.31,11.72-6.86,30.72,6,48.2,24.55,33.36,36.56,74.89,28,113.4-1.13,5.07-3.76,9.65-8.61,11.49L82.89,326.09a7.61,7.61,0,0,1-10.21-8.34c3.37-20.31,11.7-61.21-10.73-94.27C37.23,187,24.21,159.83,37.43,132.09,39.82,127.08,43.37,122.71,48.67,121Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shapes-3",
    "data-name": "Shapes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M64.62,147.14c1.43,5.62-.89,11.4-5.19,12.49s-8.8-2.42-10.22-8,2.32-11.42,6.62-12.51C61,137.75,63.2,141.52,64.62,147.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M59.78,169.65l68.74-28.44a3.77,3.77,0,0,1,5.08,2.68c1.5,6.07,8.48,17.11,10.54,20.44a3.74,3.74,0,0,1-1.67,5.39c-23.37,10.45-45.63,22-69,32.43-1.68.74-3.31-.13-4.66-1.38-4.31-4-10.63-17.41-11.23-26.82C57.41,172.12,58.08,170.34,59.78,169.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M72.06,133.22l54.11-19.52a2.47,2.47,0,0,1,3.24,2.59c-.14,2.93.58,7.42.76,10a2.56,2.56,0,0,1-1.42,2.72l-53,21.89a2.54,2.54,0,0,1-3.28-1.55c-1.45-3.34-3.19-9.63-2-14.3A2.59,2.59,0,0,1,72.06,133.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M76.93,216.61c6,6.93,15.16,23.13,16.87,37.16.4,3.25,4.39,4.82,7.36,3.32l64.08-32.3a5,5,0,0,0,2.75-5.15c-1.3-9.34-2.92-31-16.54-40.38-1.79-1.24-3.92-1.89-5.89-.95L79.12,209.54C76.43,210.83,75,214.38,76.93,216.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M98.34,269.34l38.19-19a3.5,3.5,0,0,1,5,2.73,77.44,77.44,0,0,1-2.05,29.45,3.45,3.45,0,0,1-1.79,2.24l-36.73,20.37a3.49,3.49,0,0,1-5-3.65,99.84,99.84,0,0,0,.49-28.64A3.46,3.46,0,0,1,98.34,269.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M150.19,241.33l15.33-7.6a3.65,3.65,0,0,1,5,2.28c2.67,7.11,1.71,23-.77,31a3.55,3.55,0,0,1-1.83,2.34l-15.68,8.4c-2.38,1.1-5.29-.54-5-2.9.65-4.54,3.59-18.19,1.17-30.25A3,3,0,0,1,150.19,241.33Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M478.67,368.27c-1-.17-1.62-.33-1.89-.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Laptop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Lower",
    className: "cls-29",
    d: "M461.8,289.94,387,263.2a2.93,2.93,0,0,1-.64-5.22l44.26-29.08a3,3,0,0,1,2.41-.4l71.15,18.88a2.94,2.94,0,0,1,1.17,5.08l-40.57,36.93A3,3,0,0,1,461.8,289.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Upper",
    className: "cls-30",
    d: "M505.16,247.9l-71.38-19a2.91,2.91,0,0,1-2.09-3.45l11.55-55.14A2.93,2.93,0,0,1,446.3,168l74.2,8.37a2.92,2.92,0,0,1,2.57,3.77l-14.36,65.79A2.92,2.92,0,0,1,505.16,247.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Screen",
    className: "cls-31",
    d: "M518.81,183.24l-12.65,58a2.66,2.66,0,0,1-3.24,1.8l-50.69-12.34-2.6-.63-13.1-3.19a2.66,2.66,0,0,1-1.92-3.15l10.67-50.63a2.67,2.67,0,0,1,2.8-2.08l68.37,8.74A2.67,2.67,0,0,1,518.81,183.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trackpad",
    className: "cls-32",
    d: "M437.49,277.4l-23.28-8a1.86,1.86,0,0,1-.48-3.27l9.59-7.13a6,6,0,0,1,5.15-.87l23.17,7.46a1.85,1.85,0,0,1,.68,3.2l-9,7.54A6,6,0,0,1,437.49,277.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Keyboard",
    className: "cls-33",
    d: "M437.67,232.86c9.52,2.2,45.27,12.29,57.33,15.14a2.14,2.14,0,0,1,.85,3.74l-20.19,17.38a5.79,5.79,0,0,1-5.21,1.07l-56.56-18.8a2.14,2.14,0,0,1-.62-3.82l19.84-13.85A5.8,5.8,0,0,1,437.67,232.86Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cloud"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cloud_Bg",
    "data-name": "Cloud Bg",
    className: "cls-34",
    d: "M476.64,367.84a51.07,51.07,0,0,1,8.91,28.48c0,35-37.46,63.33-83.67,63.33a105.22,105.22,0,0,1-38.63-7.15C338.53,469.36,300,477.85,268.88,477c-95.33-2.66-104.72-61.84-136.66-68.66-82.71-17.68-102-58-101.95-80.89a30,30,0,0,1,1.95-11.11c9.37-22.67,26-56,138.66-8,54.38,23.17,87.07.1,121.34,5.33,29.37,4.48,51.26,14.91,66.71,28.31a102.41,102.41,0,0,1,34.72-8.68,7.23,7.23,0,0,0,6.26-4.58c5.87-15.29,24.53-26.48,46.64-26.48,26.82,0,48.57,16.46,48.57,36.76C495.12,350.68,487.9,361.11,476.64,367.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cloud_Shadow",
    "data-name": "Cloud Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M363.25,452.5C338.53,469.36,300,477.85,268.88,477c-95.33-2.66-104.72-61.84-136.66-68.66-82.71-17.68-102-58-101.95-80.89,9.39,26,37.55,65,122,67.61,0,0-5.92,3.58-22.65,6,0,0,29.15,8.2,39.31,26.67S258.92,502.63,363.25,452.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M387.79,378.17c-15.72-25-28.86-36.21-28.86-36.21a96.66,96.66,0,0,1,16.32-5.7C365.4,344.29,381.37,367.16,387.79,378.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M485.55,396.32c0,28.66-25.16,52.88-59.67,60.68,74.94-24.71,50.76-89.16,50.76-89.16A51.07,51.07,0,0,1,485.55,396.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M495.12,339c0,11.7-7.22,22.13-18.48,28.86,18.48-22.36,16.26-31.58,13.74-44.72A29.48,29.48,0,0,1,495.12,339Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Character_Shadow",
    "data-name": "Character Shadow",
    className: "cls-39",
    d: "M120.87,329.26s22.84,28,112.07,18.67c67.48-7,49,5,105,5,17.05,0,22.92-14.79-16.16-32S202,300,178.14,303.56C155.8,306.92,110.69,298.78,120.87,329.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cup_Shadow",
    "data-name": "Cup Shadow",
    className: "cls-40",
    d: "M380.8,350.58c21.93,8,32.63,3.2,59,7.28,24.05,3.72-5.42-16.85-16.71-19.06S379.77,336.66,380.8,350.58Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cup_Plate",
    "data-name": "Cup Plate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plate"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 403.06,
    cy: 345.79,
    rx: 26.65,
    ry: 8.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-42",
    cx: 403.06,
    cy: 345.97,
    rx: 17.64,
    ry: 5.63
  })), /*#__PURE__*/React.createElement("g", {
    id: "Handle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M420.53,326.82a17.92,17.92,0,0,1,4.56-1.29,4.25,4.25,0,0,1,3.56,1.78l-7.17,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M426.91,328.93s1.93,2.31-6.5,8.05c-5.48,3.72-1.05,2.27-1.05,2.27s6.54-4.11,6.62-4.29,2.52-4.79,2.49-4.94-.23-1.3-.23-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M418.83,340.09s0-.35,0-.93c2.35-1.4,9.77-6,8.61-9.48-1-2.87-6.5.78-6.5.78s-1.61-1.3-.17-2.1c0,0,6.51-3,8.08-.83C433.22,333.73,418.83,340.09,418.83,340.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Body",
    className: "cls-41",
    d: "M403.61,348.19c-16,0-19.1-8.46-20.32-18.71a12.8,12.8,0,0,1-.12-1.5,1.85,1.85,0,0,1,0-.33c.24-2.74,9-4.95,19.76-4.95,10.58,0,19.2,2.13,19.74,4.8a2.46,2.46,0,0,1,0,.26C423.18,338.41,419.31,348.19,403.61,348.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Inside_shade",
    "data-name": "Inside shade",
    className: "cls-42",
    d: "M422.68,327.76c0,1-1.19,2-3.22,2.77-3.53,1.38-9.62,2.29-16.54,2.29-6.43,0-12.15-.79-15.76-2-2.36-.79-3.82-1.77-4-2.83a1.64,1.64,0,0,1,0-.22.41.41,0,0,1,0-.11c.24-2.74,9-4.95,19.76-4.95,10.58,0,19.2,2.13,19.74,4.8A2.46,2.46,0,0,1,422.68,327.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tea_Color",
    "data-name": "Tea Color",
    className: "cls-43",
    d: "M419.46,330.53c-3.53,1.38-9.62,2.29-16.54,2.29-6.43,0-12.15-.79-15.76-2,2.11-1.78,8.63-3.09,16.34-3.09C410.79,327.72,417,328.89,419.46,330.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Smoke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M417.9,316.63c-.51,5.09-4.24,13.86-16.69,13.08-.8,0-1.65-.13-2.53-.27-8.37-1.27-24.05-17.58-7.1-34.79,11.34-11.51,9.38-21,10.18-21.58a.18.18,0,0,1,.16,0c7.11,2.71,7.28,8.36,4.14,26.25C404.77,306.68,419,305.91,417.9,316.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M404,287.78c-3.28,11.72-16.44,34.8-2.85,41.89l.07,0c-.8,0-1.65-.13-2.53-.27-8.37-1.27-24.05-17.58-7.1-34.79,11.34-11.51,9.38-21,10.18-21.58C403.72,275.51,406.09,280.27,404,287.78Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head_and_Shoulders",
    "data-name": "Head and Shoulders"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hair"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M387,174.89h0c-1.3,1.1-99.55,83.79-184.24,53.49-15-5.35-25.26-12.67-31.59-20.47-15.92-19.64.27-47.12,22.69-49.75,0,0,10.48-35.28,76.82-9.28C306,162.89,327,161.22,327,161.22s1.26,4.12-5.67,9.67c-6.22,5,1.39,3.1,13.55.65C351.67,168.17,377.23,163.72,387,174.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M386.94,174.9c-1.3,1.1-99.55,83.79-184.24,53.49-15-5.35-16.51-4.24-22.84-12,16.1,6.57,32.42,7.9,68,5C318.24,215.71,318,198.56,386.94,174.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M334.83,171.54h0C303.21,180.71,298,174.9,298,174.9c9.75-.24,29-13.68,29-13.68s1.26,4.12-5.67,9.67C315.06,175.87,322.67,174,334.83,171.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ear",
    className: "cls-48",
    d: "M229.15,195.36c0-.14-.63-7.34,2.25-7.71s3.25.87,2.5,2.75-2,4.5-2.27,5.5A1.28,1.28,0,0,1,229.15,195.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Neck",
    className: "cls-49",
    d: "M211.4,238.52c-24.25.75-37.62-10.62-33.5-14.87C181,220.48,193.06,220,199,220a15.23,15.23,0,0,0,9.34-3.13,7.44,7.44,0,0,0,3-5.88c.87-2.48,4.27-7.71,7-9.83a4.25,4.25,0,0,1,2.51-.78,14.71,14.71,0,0,1,5.9,1.55c-3.54,8.09-6.17,13.47-4.69,17.55,1,2.84,6.91,2.43,12.12,4.3a3.16,3.16,0,0,1,1.18.74C238.6,227.74,233.47,237.84,211.4,238.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Neck_Shadow",
    "data-name": "Neck Shadow",
    className: "cls-50",
    d: "M235.42,224.51a70.74,70.74,0,0,1-12.19,2c-11.43.5-7.24-14.17-7.24-14.17s1.41-7.33,4.92-11.95a14.71,14.71,0,0,1,5.9,1.55c-3.54,8.09-6.17,13.47-4.69,17.55,1,2.84,6.91,2.43,12.12,4.3A3.16,3.16,0,0,1,235.42,224.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Face",
    className: "cls-51",
    d: "M228.15,194.91c0,6.94-3.58,14.13-8.64,16.55a8.24,8.24,0,0,1-4.06.86c-6.51-.3-10.94-8.72-13.56-16.75-1.62-5-1.18-9.87,1.24-13.07a26.44,26.44,0,0,0,9.7,4.3c2,.42,3.67.75,5.13,1,4.92.89,7.16,1,9,1.74A13.09,13.09,0,0,1,228.15,194.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Face_Shadow",
    "data-name": "Face Shadow",
    className: "cls-52",
    d: "M228.15,194.91c0,6.94-3.58,14.13-8.64,16.55,2.82-11.05,1.28-18.59-1.55-23.65,4.92.89,7.16,1,9,1.74A13.09,13.09,0,0,1,228.15,194.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dress",
    className: "cls-41",
    d: "M176.84,223.2s6.62-3.45,12.5-3.29l13.39,5.84a6,6,0,0,0,3.58.39l25.67-5a3.17,3.17,0,0,1,1.53.08l10.58,3.19-1.75,13.5-20,9.66-17,1.46-27.63-13.75L169.46,228Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    className: "cls-47",
    d: "M226.6,189.42c-4.15-.52-9.58-1.24-16.69-2.22-26.31-3.64-17.33-26.22-16.22-28.79-4.28,12.7,6.39,25.67,19.14,28.39C221.09,188.56,224.25,188.64,226.6,189.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Left_Side_Arm",
    "data-name": "Left Side Arm",
    className: "cls-53",
    d: "M98.42,250.47s-3.59,12.33,4.08,19.75,12.42,7.33,12.42,7.33l2.75-11.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Paper-2",
    "data-name": "Paper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Paper_BG",
    "data-name": "Paper BG",
    className: "cls-15",
    d: "M299.93,282c.05,4.11-3.5,6.81-7.61,6.81-25.49,0-91.39,16.52-91.39,16.52s-56.05-14.91-86.83-14.47a6.29,6.29,0,0,1-6.39-6.15l-1.6-62.22a5.08,5.08,0,0,1,5.06-5.25c38.41.34,77.38,9.54,89.76,12.79h0s59-17.79,91.24-14.91a7.67,7.67,0,0,1,7,7.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shapes-4",
    "data-name": "Shapes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M116,228.63l1,34.65a2.88,2.88,0,0,0,2.58,2.78l3.77.4a2.88,2.88,0,0,0,3.18-2.91L126,229a2.88,2.88,0,0,0-2.53-2.81l-4.23-.51A2.88,2.88,0,0,0,116,228.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M120.45,269.71l3.63.43a2.88,2.88,0,0,1,2.53,2.87l0,7a2.88,2.88,0,0,1-3.25,2.83l-3.64-.49a2.87,2.87,0,0,1-2.49-2.87l0-7A2.86,2.86,0,0,1,120.45,269.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M132.5,226.89l8.13,1a2.87,2.87,0,0,1,2.53,2.85v24.83a2.87,2.87,0,0,1-3.27,2.84l-8.13-1.12a2.88,2.88,0,0,1-2.47-2.85V229.74A2.87,2.87,0,0,1,132.5,226.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M132.34,260.41l8.15,1.06a2.88,2.88,0,0,1,2.5,2.83l.15,17.4a2.87,2.87,0,0,1-3.21,2.88l-8.3-1a2.88,2.88,0,0,1-2.53-2.86V263.26A2.86,2.86,0,0,1,132.34,260.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M149.29,230l10.25,1.07a2.87,2.87,0,0,1,2.58,2.86v30.59a2.87,2.87,0,0,1-3.22,2.85l-10.25-1.23a2.87,2.87,0,0,1-2.53-2.85V232.9A2.88,2.88,0,0,1,149.29,230Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M149.38,269.65,159.63,271a2.88,2.88,0,0,1,2.49,2.85v.77a2.87,2.87,0,0,1-3.2,2.85l-10.25-1.17a2.88,2.88,0,0,1-2.55-2.86v-1A2.88,2.88,0,0,1,149.38,269.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M168.41,232.56l25.07,4a2.59,2.59,0,0,1,2.18,2.56v15.71a2.59,2.59,0,0,1-3,2.54l-25.08-4.45a2.59,2.59,0,0,1-2.13-2.55V235.12A2.59,2.59,0,0,1,168.41,232.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M168.79,256.16l7.42,1.33a2.88,2.88,0,0,1,2.36,2.83V274a2.88,2.88,0,0,1-3.29,2.85l-7.41-1.09a2.88,2.88,0,0,1-2.46-2.84V259A2.87,2.87,0,0,1,168.79,256.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M184,258.38l7.92,1.12a2.87,2.87,0,0,1,2.47,2.84v14.93a2.88,2.88,0,0,1-3.3,2.84l-7.92-1.19a2.87,2.87,0,0,1-2.44-2.84V261.23A2.87,2.87,0,0,1,184,258.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M225.52,290.46l-16.27,2.74a2.59,2.59,0,0,1-3-2.57l.46-50a2.58,2.58,0,0,1,2.1-2.51L225.06,235a2.58,2.58,0,0,1,3.06,2.56l-.45,50.35A2.58,2.58,0,0,1,225.52,290.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M232.64,233.36c2.17-.49,5.74-1.27,8.56-1.75a2.48,2.48,0,0,1,2.89,2.45v20.23a2.49,2.49,0,0,1-1.89,2.42l-8.41,2.08a2.49,2.49,0,0,1-3.08-2.41v-20.6A2.47,2.47,0,0,1,232.64,233.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M232.5,261.68l8.39-2.31A2.47,2.47,0,0,1,244,261.8l-.39,23.28a2.48,2.48,0,0,1-2.08,2.41l-8.39,1.38a2.48,2.48,0,0,1-2.89-2.49l.4-22.35A2.48,2.48,0,0,1,232.5,261.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M246.06,233.06v31.32a2.48,2.48,0,0,0,3,2.44c5.45-1.11,17.24-3.43,25.52-4.5a2.47,2.47,0,0,0,2.17-2.46V228.52a2.48,2.48,0,0,0-2.83-2.46c-5.13.73-16.34,2.43-25.91,4.58A2.46,2.46,0,0,0,246.06,233.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M248,269.21c5.07-1.06,18.64-3.85,25.89-4.81a2.48,2.48,0,0,1,2.8,2.47v12.54a2.48,2.48,0,0,1-2.11,2.46l-25.7,3.87a2.48,2.48,0,0,1-2.85-2.46V271.64A2.48,2.48,0,0,1,248,269.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M281.36,225.35l4.61-.7a2.48,2.48,0,0,1,2.86,2.45V278a2.49,2.49,0,0,1-2.13,2.46l-4.61.68a2.48,2.48,0,0,1-2.84-2.46V227.81A2.48,2.48,0,0,1,281.36,225.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Paper_shadow",
    "data-name": "Paper shadow",
    className: "cls-58",
    d: "M299.93,282c.05,4.11-3.5,6.81-7.61,6.81-25.83,0-91.39,16.52-91.39,16.52V230h0s59-17.79,91.24-14.91a7.67,7.67,0,0,1,7,7.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hand_Left_Side",
    "data-name": "Hand Left Side"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M105.53,241l-2.9,3.46,2-.87,5.38-.5c2.81,1.43,2.81,11.06,2.81,11.06l-4.06,3.42-.87.73a2.37,2.37,0,0,1-3,0c-2-1.61-5.41-4.32-6.49-4.93-1.57-.88-2.32-8.31-2.32-8.31,1.75-.88,7.82-7.75,7.82-7.75a28.26,28.26,0,0,0,11.58-1.11C116.65,241.28,105.53,241,105.53,241Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M112.85,254l-4.06,3.42c-.23-5.49-4.13-14-4.13-14L110,243C112.85,244.39,112.85,254,112.85,254Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dress-2",
    "data-name": "Dress"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Dress-3",
    "data-name": "Dress",
    className: "cls-41",
    d: "M277.48,307.1c-.83,17.67-35.66,13.34-35.66,13.34l-1.7-.84c-10.21-5.12-63-32-60.14-40,0,0,15.57-.23,36.86,8.65l.24.11a130.37,130.37,0,0,1,12.65,6.12,88.47,88.47,0,0,1,21.38-5.93c2.25-.35,4.64-.66,7.15-.88.73-.07,1.47-.12,2.22-.17C260.48,287.5,278.26,290.67,277.48,307.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow-2",
    "data-name": "Shadow",
    className: "cls-61",
    d: "M277.48,307.1c-.83,17.67-35.66,13.34-35.66,13.34l-1.7-.84c4-2.12,19.32-3.49,24-7.21,10.68-8.48,3.83-20.17-5.85-24.72.73-.07,1.47-.12,2.22-.17C260.48,287.5,278.26,290.67,277.48,307.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow-3",
    "data-name": "Shadow",
    className: "cls-61",
    d: "M237.73,298.45c-2.73-.56-6-1.49-13.29-5.85-1.84-1.09-6-3.56-7.36-4.24a130.37,130.37,0,0,1,12.65,6.12,88.47,88.47,0,0,1,21.38-5.93l0,.05C254.73,291.93,248.23,300.6,237.73,298.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow-4",
    "data-name": "Shadow",
    className: "cls-62",
    d: "M190.77,281.55s9.47,2.48,24.77,15,24,16.56,32.15,17.5-8.33,4.38-8.33,4.38l-31.5-10.63-17.09-11.12-2.41-14.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M310,241.3l0,0c-.33.87-5.77,15-11.11,14.59-3.3-.24-5.3-3.1-6.34-5.24a14.93,14.93,0,0,1-.91-2.33,4,4,0,0,1-2.81-.56c-1.19-.87,1.37-4.06,1.37-4.06-1.31-.19-3.52-2.35-2.75-2.44,1.43-.15,6.8-3.34,9.43-3.24a15.63,15.63,0,0,1,3.73,1.55c-.05-.05-.25-.24-1-.89-1-.92-.58-1.25-7.42-1.92-5.05-.49-5.68-3.6-5.67-5.19a.52.52,0,0,1,.79-.45c1.75,1.1,6.79,3.61,15.55,3C302.85,234.17,305.1,240.43,310,241.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M310,241.34c-.33.87-5.77,15-11.11,14.59-3.3-.24-5.3-3.1-6.34-5.24A35.67,35.67,0,0,0,310,241.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Leg_Back",
    "data-name": "Leg Back"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M297.37,323.83c-6,4.21-15.59,5.15-26.8,4.82-11.78-.34-25.37-2.09-38.56-2.94l-1.69-.11c-31.34-1.83-55,16.34-79.5,12-10.86-1.92-18.51-3.51-23.67-4.69a12.19,12.19,0,0,1-9.48-12.15c0-2.17.14-4.34.23-6.12a7.37,7.37,0,0,1,4.19-6.24c37.82-18.22,80.5.52,91.31,5.37a26,26,0,0,0,8.23,2,64.07,64.07,0,0,0,10.64,0c10-.73,21.93-3.19,33.72-6,2.08-.49,4.17-1,6.24-1.51,9.78-2.41,16.85-1,21.72,1.27-.09,2-1.35,4.65-7.53,4.65,0,0-1.43,1.19.75,1.44S297.07,317.45,297.37,323.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M297.37,323.84c-11.95,8.35-37.91,3.84-62.91,2q-2.07-.15-4.14-.27c-31.34-1.83-55,16.34-79.5,12-10.86-1.92-18.51-3.51-23.67-4.69a12.17,12.17,0,0,1-6.28-3.65c4.84,1.48,16.88,4.27,34.61,2.51,13.21-1.31,40.42-9.33,66.15-16,13,1.23,32.34-3,50.6-7.53,9-2.23,15.76-1.23,20.57.76.4.16.78.33,1.15.51-.09,2-1.35,4.65-7.53,4.65,0,0-1.27,1.06.41,1.39h0l.32.05C289.26,315.79,297.08,317.46,297.37,323.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M286.83,315.5s-1.68-.09-1.41-1.37c.46-2.2,6.5-1.64,7.22-4.27,0-.21.15-.85.16-.91.4.16.78.33,1.15.51-.09,2-1.35,4.65-7.53,4.65C286.42,314.11,285.15,315.17,286.83,315.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M297.37,323.84c-11.95,8.35-37.91,3.84-62.91,2C255.79,327.3,297.37,323.84,297.37,323.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M294.57,333.32c-1,2.84-9.21-.44-9.21-.44s-1.15-.12-1.08.49c-.06-.18-.65-1.88,1.45-1.94S291.57,333.51,294.57,333.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shoe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoe_Back",
    "data-name": "Shoe Back",
    className: "cls-46",
    d: "M303.25,317.72a2.23,2.23,0,0,1-.24.49c-13.9,21-44.2,9.76-44.2,9.76l6.92.41a2.08,2.08,0,0,0,1.42-.44l9.61-7.56a2,2,0,0,0,.36-.36,2.09,2.09,0,0,0-.64-3.12l-11.58-6.39a2.09,2.09,0,0,0-1.47-.21l-7,1.57c29.56-13.14,43-.4,46.46,3.81A2.13,2.13,0,0,1,303.25,317.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Shoe_Shadow",
    "data-name": " Shoe Shadow",
    className: "cls-47",
    d: "M303.25,317.72a2.23,2.23,0,0,1-.24.49c-13.9,21-44.2,9.76-44.2,9.76l6.92.41a2.08,2.08,0,0,0,1.42-.44l9.61-7.56a2,2,0,0,0,.36-.36A151.78,151.78,0,0,0,303.25,317.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Leg_Front",
    "data-name": "Leg Front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Leg_Front-2",
    "data-name": "Leg Front",
    className: "cls-70",
    d: "M294.61,333.22c-.88,3-9.25-.34-9.25-.34s-2.42-.25,0,1.84,4.37,3.41,4.13,4.39a3.87,3.87,0,0,1-1.51,2.3c-5.48.4-12.79-.47-21.5-4.76a65.11,65.11,0,0,1-7.47-4.36,80.91,80.91,0,0,0-11.87-6.63c-37.07-16.87-72.4,1.07-103.43-20.89q-1.78-1.27-3.55-2.71a7.58,7.58,0,0,1-2.66-7.46c1.15-5.31,4.19-13.53,12.08-14.82,10.27-1.68,37.75-3.47,50.75,6.53,9.77,7.51,23.27,22.29,36.36,27.52a23.45,23.45,0,0,0,9.42,1.87c1.47-.05,2.93-.07,4.37-.08a120.68,120.68,0,0,1,22.65,1.72c7.51,1.38,13.9,3.63,18.46,6.94C293,327.53,294.93,332.11,294.61,333.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg_Shadow",
    "data-name": "Leg Shadow",
    className: "cls-71",
    d: "M294.61,333.22a.42.42,0,0,1,0,.1c-1,2.84-9.21-.44-9.21-.44s-1.15-.12-1.08.49h0c0,.28.32.7,1.07,1.34,2.42,2.08,4.37,3.41,4.13,4.39a4.1,4.1,0,0,1-.66,1.46,3.75,3.75,0,0,1-.85.84c-7,.5-16.94-1.05-29-9.12a82.74,82.74,0,0,0-31.82-12.82l-.21,0c-29.7-5.41-57.92,3.28-83.27-14.66,6.45,2.52,21.44,7.65,37.06,7.75,19.13.12,34.91-1.75,55.92,1.31a23.45,23.45,0,0,0,9.42,1.87c18.79-.62,36,1.73,45.47,8.57C293,327.52,294.93,332.11,294.61,333.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg_Shadow_small",
    "data-name": "Leg Shadow small",
    className: "cls-72",
    d: "M288.83,340.57a3.75,3.75,0,0,1-.85.84c-7,.5-16.94-1.05-29-9.12a82.74,82.74,0,0,0-31.82-12.82c2.07.34,18.87,3.26,26.84,7.16C260.68,329.89,276.14,337.07,288.83,340.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shoe-2",
    "data-name": "Shoe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoe_front",
    "data-name": "Shoe front",
    className: "cls-46",
    d: "M298.27,337.58a1.84,1.84,0,0,1-.22.17l-.1.06c-4.3,2.3-23.16,10.64-42.77-7.94l5,2.64a1.53,1.53,0,0,0,1,.12l4.11-1.05,9-2.29.34-.09a1.44,1.44,0,0,0,.82-2.22L269,317.75a1.46,1.46,0,0,0-.93-.59l-7.63-1.3s33.61-3.21,38.21,20.42A1.45,1.45,0,0,1,298.27,337.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shoe_shadow",
    "data-name": "Shoe shadow",
    className: "cls-47",
    d: "M298.27,337.58a1.84,1.84,0,0,1-.22.17l-.1.06c-4.3,2.3-23.16,10.64-42.77-7.94l5,2.64a1.53,1.53,0,0,0,1,.12l4.11-1.05,9-2.29A138.45,138.45,0,0,0,298.27,337.58Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.bc0b540f17e20460cdc0cd4ce72d51f4.svg";
export { ForwardRef as ReactComponent };